import { z } from "zod";

export const ShopifyLoginRequestBodySchema = z.object({
  shopId: z.string(),
});

export const ShopifyLoginResponseBodySchema = z.object({
  user: z.object({
    redirect: z.string(),
  }),
});

export type ShopifyLoginRequestBodyType = z.infer<
  typeof ShopifyLoginRequestBodySchema
>;

export type ShopifyLoginResponseBodyType = z.infer<
  typeof ShopifyLoginResponseBodySchema
>;
